<template>
  <el-dialog
    title="绑定微信登录"
    :visible.sync="visible"
    width="420px"
    :close-on-click-modal="false"
    append-to-body
    @closed="handleClosed"
  >
    <p class="wx-bind-self__tip">请使用微信扫描下方二维码完成绑定</p>
    <!-- v-if 保证每次打开重新出码、关闭即销毁清理定时器与监听 -->
    <wx-scan-login
      v-if="visible"
      ref="wxScan"
      scene="bind"
      @code="onCode"
      @error="onError"
    />
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from '@qs/ui'
import { bindUserByCode } from '@/api/wechatLogin'
import WxScanLogin from '@/components/WxScanLogin'

const emit = defineEmits(['success'])

const wxScan = ref(null)
const visible = ref(false)
// 绑定请求进行中，避免同一 code 重复提交
let binding = false

const retry = () => {
  binding = false
  if (wxScan.value) wxScan.value.refresh()
}

// 自助绑定：不传 userId，后端按 token 认本人
const onCode = ({ code, state }) => {
  if (binding) return
  binding = true
  bindUserByCode({ code, state })
    .then((res) => {
      // T16：code===1 即判绑定成功，不依赖出参内容
      if (res && res.code === 1) {
        Message.success('绑定成功')
        visible.value = false
        emit('success')
      } else {
        // code!==1：msg 已由 request 弹出，重新出码允许再扫
        retry()
      }
    })
    .catch(() => {
      retry()
    })
}

const onError = () => {
  // 出码失败由 WxScanLogin 内部展示重试入口
}

const handleClosed = () => {
  binding = false
}

// 供父组件通过 ref 调用
const open = () => {
  binding = false
  visible.value = true
}

defineExpose({ open })
</script>

<style lang="scss" scoped>
.wx-bind-self__tip {
  margin: 0 0 12px;
  font-size: 13px;
  color: #909399;
  text-align: center;
}
</style>
